/*
 * Proprietary and confidential | 2023 | SoundTalks NV
 */

import { fromJS } from 'immutable';
import * as constants from '../constants/batches';
import LoadingProgress from 'data/utils/reducers/loading';
import Pagination from 'data/utils/reducers/pagination';
export const activeBatchLoadingProgress = new LoadingProgress('activeBatch');
export const batchesLoadingProgress = new LoadingProgress('allBatches');

export const commentsLoadingProgress = new LoadingProgress('comments');
export const recommendationsLoadingProgress = new LoadingProgress('recommendations');
export const treatmentsLoadingProgress = new LoadingProgress('treatments');

export const eventDataLoadingProgress = new LoadingProgress('eventData');

export const rhsDataLoadingProgress = new LoadingProgress('rhsData');
export const rhsColorDataLoadingProgress = new LoadingProgress('rhsColorData');
export const temperatureDataLoadingProgress = new LoadingProgress('temperatureData');
export const humidityDataLoadingProgress = new LoadingProgress('humidityData');
export const alertColorDataLoadingProgress = new LoadingProgress('alertColorData');

export const rhsDeviceDataLoadingProgress = new LoadingProgress('rhsDeviceData');
export const allDevicesRhsDataLoadingProgress = new LoadingProgress('allDevicesRhsData');
export const rhsColorDeviceDataLoadingProgress = new LoadingProgress('rhsColorDeviceData');
export const temperatureDeviceDataLoadingProgress = new LoadingProgress('temperatureDeviceData');
export const humidityDeviceDataLoadingProgress = new LoadingProgress('humidityDeviceData');

export const peakCoughingHourDataLoadingProgress = new LoadingProgress('peakCoughingHourData');
export const peakCoughingHourDeviceDataLoadingProgress = new LoadingProgress('peakCoughingHourDeviceData');
export const mortalityPercentageDataLoadingProgress = new LoadingProgress('mortalityPercentageData');

export const mortalityDataLoadingProgress = new LoadingProgress('mortalityData');
export const mortalityReasonsLoadingProgress = new LoadingProgress('mortalityReasons');

export const logbookLoadingProgress = new LoadingProgress('logbook');

export const siteBatchesLoadingProgress = new LoadingProgress('siteBatches');
export const siteExportsLoadingProgress = new LoadingProgress('siteExports');
export const createExportsLoadingProgress = new LoadingProgress('createExports');

export const airspaceExportsLoadingProgress = new LoadingProgress('airspaceExports');

export const v3SiteBatchesLoadingProgress = new LoadingProgress('v3SiteBatches');
export const v3SiteBatchesPagination = new Pagination('v3SiteBatches');

const loadActiveBatch = (state, action) =>
  state.withMutations((newState) => {
    newState.set('activeBatch', fromJS(action.payload));
    activeBatchLoadingProgress.setLoaded(newState);
  });

const loadBatches = (state, action) =>
  state.withMutations((newState) => {
    newState.set('allBatches', fromJS(action.payload));
    batchesLoadingProgress.setLoaded(newState);
  });

const loadComments = (state, action) =>
  state.withMutations((newState) => {
    newState.set('comments', fromJS(action.payload));
    commentsLoadingProgress.setLoaded(newState);
  });

const loadRecommendations = (state, action) =>
  state.withMutations((newState) => {
    newState.set('recommendations', fromJS(action.payload));
    recommendationsLoadingProgress.setLoaded(newState);
  });

const loadTreatments = (state, action) =>
  state.withMutations((newState) => {
    newState.set('treatments', fromJS(action.payload));
    treatmentsLoadingProgress.setLoaded(newState);
  });

const loadEventData = (state, action) =>
  state.withMutations((newState) => {
    newState.set('eventData', fromJS(action.payload));
    eventDataLoadingProgress.setLoaded(newState);
  });

const loadRhsData = (state, action) =>
  state.withMutations((newState) => {
    newState.set('rhsData', fromJS(action.payload));
    rhsDataLoadingProgress.setLoaded(newState);
  });

const loadRhsColorData = (state, action) =>
  state.withMutations((newState) => {
    newState.set('rhsColorData', fromJS(action.payload));
    rhsColorDataLoadingProgress.setLoaded(newState);
  });

const loadTemperatureData = (state, action) =>
  state.withMutations((newState) => {
    newState.set('temperatureData', fromJS(action.payload));
    temperatureDataLoadingProgress.setLoaded(newState);
  });

const loadHumidityData = (state, action) =>
  state.withMutations((newState) => {
    newState.set('humidityData', fromJS(action.payload));
    humidityDataLoadingProgress.setLoaded(newState);
  });

const loadAlertColorData = (state, action) =>
  state.withMutations((newState) => {
    newState.set('alertColorData', fromJS(action.payload));
    alertColorDataLoadingProgress.setLoaded(newState);
  });

const loadRhsDeviceData = (state, action) =>
  state.withMutations((newState) => {
    newState.setIn(['device', 'rhsDeviceData'], fromJS(action.payload));
    rhsDeviceDataLoadingProgress.setLoaded(newState);
  });

const loadAllDevicesRhsData = (state, action) =>
  state.withMutations((newState) => {
    newState.set('allDevicesRhsData', fromJS(action.payload));
    allDevicesRhsDataLoadingProgress.setLoaded(newState);
  });

const loadRhsColorDeviceData = (state, action) =>
  state.withMutations((newState) => {
    newState.setIn(['device', 'rhsColorDeviceData'], fromJS(action.payload));
    rhsColorDeviceDataLoadingProgress.setLoaded(newState);
  });

const loadTemperatureDeviceData = (state, action) =>
  state.withMutations((newState) => {
    newState.setIn(['device', 'temperatureDeviceData'], fromJS(action.payload));
    temperatureDeviceDataLoadingProgress.setLoaded(newState);
  });

const loadHumidityDeviceData = (state, action) =>
  state.withMutations((newState) => {
    newState.setIn(['device', 'humidityDeviceData'], fromJS(action.payload));
    humidityDeviceDataLoadingProgress.setLoaded(newState);
  });

const loadPeakCoughingHourData = (state, action) =>
  state.withMutations((newState) => {
    newState.set('peakCoughingHourData', fromJS(action.payload));
    peakCoughingHourDataLoadingProgress.setLoaded(newState);
  });

const loadPeakCoughingHourDeviceData = (state, action) =>
  state.withMutations((newState) => {
    newState.setIn(['device', 'peakCoughingHourDeviceData'], fromJS(action.payload));
    peakCoughingHourDeviceDataLoadingProgress.setLoaded(newState);
  });

const loadMortalityData = (state, action) =>
  state.withMutations((newState) => {
    newState.set('mortalityData', fromJS(action.payload));
    mortalityDataLoadingProgress.setLoaded(newState);
  });

const loadMortalityPercentageData = (state, action) =>
  state.withMutations((newState) => {
    newState.set('mortalityPercentageData', fromJS(action.payload));
    mortalityPercentageDataLoadingProgress.setLoaded(newState);
  });

const loadMortalityReasons = (state, action) =>
  state.withMutations((newState) => {
    newState.set('mortalityReasons', fromJS(action.payload));
    mortalityReasonsLoadingProgress.setLoaded(newState);
  });

const loadLogbook = (state, action) =>
  state.withMutations((newState) => {
    const {
      total,
      entities: { logbookItems },
      lazy,
    } = action.payload;
    newState.setIn(['logbook', 'total'], fromJS(total));
    // eslint-disable-next-line no-unused-expressions
    lazy
      ? newState.mergeIn(['logbook', 'entities'], fromJS(logbookItems))
      : newState.setIn(['logbook', 'entities'], fromJS(logbookItems));
    logbookLoadingProgress.setLoaded(newState);
  });

const loadSiteBatches = (state, action) =>
  state.withMutations((newState) => {
    newState.set('siteBatches', fromJS(action.payload));
    siteBatchesLoadingProgress.setLoaded(newState);
  });

const loadSiteExports = (state, action) =>
  state.withMutations((newState) => {
    newState.set('siteExports', fromJS(action.payload));
    siteExportsLoadingProgress.setLoaded(newState);
  });

const loadAirspaceExports = (state, action) =>
  state.withMutations((newState) => {
    newState.set('airspaceExports', fromJS(action.payload));
    airspaceExportsLoadingProgress.setLoaded(newState);
  });

const loadV3SiteBatches = (state, action) =>
  state.withMutations((newState) => {
    const { items, perPage, total } = action.payload;
    v3SiteBatchesPagination.set(newState, total, perPage, fromJS(items));
    v3SiteBatchesLoadingProgress.setLoaded(newState);
  });

const clear = (state) =>
  state.withMutations((newState) => {
    activeBatchLoadingProgress.clear(newState);
    batchesLoadingProgress.clear(newState);
    commentsLoadingProgress.clear(newState);
    recommendationsLoadingProgress.clear(newState);
    treatmentsLoadingProgress.clear(newState);
    rhsDataLoadingProgress.clear(newState);
    rhsColorDataLoadingProgress.clear(newState);
    temperatureDataLoadingProgress.clear(newState);
    humidityDataLoadingProgress.clear(newState);
    alertColorDataLoadingProgress.clear(newState);
    rhsDeviceDataLoadingProgress.clear(newState);
    allDevicesRhsDataLoadingProgress.clear(newState);
    rhsColorDeviceDataLoadingProgress.clear(newState);
    temperatureDeviceDataLoadingProgress.clear(newState);
    humidityDeviceDataLoadingProgress.clear(newState);
    peakCoughingHourDataLoadingProgress.clear(newState);
    peakCoughingHourDeviceDataLoadingProgress.clear(newState);
    mortalityPercentageDataLoadingProgress.clear(newState);
    logbookLoadingProgress.clear(newState);
    siteBatchesLoadingProgress.clear(newState);
    siteExportsLoadingProgress.clear(newState);
    createExportsLoadingProgress.clear(newState);
    airspaceExportsLoadingProgress.clear(newState);
    v3SiteBatchesLoadingProgress.clear(newState);
  });

const clearLogbook = (state) =>
  state.withMutations((newState) => {
    logbookLoadingProgress.clear(newState);
    newState.set('logbook', fromJS({ total: null, entities: {} }));
  });

const clearGraphs = (state) =>
  state.withMutations((newState) => {
    commentsLoadingProgress.clear(newState);
    recommendationsLoadingProgress.clear(newState);
    treatmentsLoadingProgress.clear(newState);
    rhsDataLoadingProgress.clear(newState);
    rhsColorDataLoadingProgress.clear(newState);
    temperatureDataLoadingProgress.clear(newState);
    humidityDataLoadingProgress.clear(newState);
    alertColorDataLoadingProgress.clear(newState);
    rhsDeviceDataLoadingProgress.clear(newState);
    allDevicesRhsDataLoadingProgress.clear(newState);
    rhsColorDeviceDataLoadingProgress.clear(newState);
    temperatureDeviceDataLoadingProgress.clear(newState);
    humidityDeviceDataLoadingProgress.clear(newState);
    peakCoughingHourDataLoadingProgress.clear(newState);
    peakCoughingHourDeviceDataLoadingProgress.clear(newState);
    mortalityDataLoadingProgress.clear(newState);
    mortalityPercentageDataLoadingProgress.clear(newState);
    mortalityReasonsLoadingProgress.clear(newState);
  });

const initialState = fromJS({
  activeBatch: {},
  allBatches: { total: null, items: [] },
  comments: [],
  recommendations: [],
  treatments: [],
  eventData: [],
  rhsData: [],
  rhsColorData: [],
  allDevicesRhsData: [],
  temperatureData: [],
  humidityData: [],
  alertColorData: { data: [] },
  peakCoughingHourData: [],
  mortalityData: [],
  mortalityPercentageData: [],
  mortalityReasons: [],
  device: {
    rhsDeviceData: [],
    rhsColorDeviceData: [],
    temperatureDeviceData: [],
    humidityDeviceData: [],
    peakCoughingHourDeviceData: [],
  },
  logbook: { total: null, entities: {} },
  siteBatches: [],
  siteExports: { total: null, items: [] },
  airspaceExports: { total: null, items: [] },
  v3SiteBatches: { total: null, items: [] },
});

export default (state = initialState, action) => {
  switch (action.type) {
    case constants.ACTIVE_BATCH_LOAD_START:
      return activeBatchLoadingProgress.setLoading(state);
    case constants.ACTIVE_BATCH_LOAD_FAILED:
      return activeBatchLoadingProgress.setLoadFailed(state);
    case constants.ACTIVE_BATCH_LOAD_SUCCESS:
      return loadActiveBatch(state, action);

    case constants.BATCHES_LOAD_START:
      return batchesLoadingProgress.setLoading(state);
    case constants.BATCHES_LOAD_FAILED:
      return batchesLoadingProgress.setLoadFailed(state);
    case constants.BATCHES_LOAD_SUCCESS:
      return loadBatches(state, action);

    case constants.COMMENTS_LOAD_START:
      return commentsLoadingProgress.setLoading(state);
    case constants.COMMENTS_LOAD_FAILED:
      return commentsLoadingProgress.setLoadFailed(state);
    case constants.COMMENTS_LOAD_SUCCESS:
      return loadComments(state, action);

    case constants.RECOMMENDATIONS_LOAD_START:
      return recommendationsLoadingProgress.setLoading(state);
    case constants.RECOMMENDATIONS_LOAD_FAILED:
      return recommendationsLoadingProgress.setLoadFailed(state);
    case constants.RECOMMENDATIONS_LOAD_SUCCESS:
      return loadRecommendations(state, action);

    case constants.TREATMENTS_LOAD_START:
      return treatmentsLoadingProgress.setLoading(state);
    case constants.TREATMENTS_LOAD_FAILED:
      return treatmentsLoadingProgress.setLoadFailed(state);
    case constants.TREATMENTS_LOAD_SUCCESS:
      return loadTreatments(state, action);

    case constants.EVENT_DATA_LOAD_START:
      return eventDataLoadingProgress.setLoading(state);
    case constants.EVENT_DATA_LOAD_FAILED:
      return eventDataLoadingProgress.setLoadFailed(state);
    case constants.EVENT_DATA_LOAD_SUCCESS:
      return loadEventData(state, action);

    case constants.RHS_DATA_LOAD_START:
      return rhsDataLoadingProgress.setLoading(state);
    case constants.RHS_DATA_LOAD_FAILED:
      return rhsDataLoadingProgress.setLoadFailed(state);
    case constants.RHS_DATA_LOAD_SUCCESS:
      return loadRhsData(state, action);

    case constants.RHS_COLOR_DATA_LOAD_START:
      return rhsColorDataLoadingProgress.setLoading(state);
    case constants.RHS_COLOR_DATA_LOAD_FAILED:
      return rhsColorDataLoadingProgress.setLoadFailed(state);
    case constants.RHS_COLOR_DATA_LOAD_SUCCESS:
      return loadRhsColorData(state, action);

    case constants.TEMPERATURE_DATA_LOAD_START:
      return temperatureDataLoadingProgress.setLoading(state);
    case constants.TEMPERATURE_DATA_LOAD_FAILED:
      return temperatureDataLoadingProgress.setLoadFailed(state);
    case constants.TEMPERATURE_DATA_LOAD_SUCCESS:
      return loadTemperatureData(state, action);

    case constants.HUMIDITY_DATA_LOAD_START:
      return humidityDataLoadingProgress.setLoading(state);
    case constants.HUMIDITY_DATA_LOAD_FAILED:
      return humidityDataLoadingProgress.setLoadFailed(state);
    case constants.HUMIDITY_DATA_LOAD_SUCCESS:
      return loadHumidityData(state, action);

    case constants.ALERT_COLOR_DATA_LOAD_START:
      return alertColorDataLoadingProgress.setLoading(state);
    case constants.ALERT_COLOR_DATA_LOAD_FAILED:
      return alertColorDataLoadingProgress.setLoadFailed(state);
    case constants.ALERT_COLOR_DATA_LOAD_SUCCESS:
      return loadAlertColorData(state, action);

    case constants.RHS_DEVICE_DATA_LOAD_START:
      return rhsDeviceDataLoadingProgress.setLoading(state);
    case constants.RHS_DEVICE_DATA_LOAD_FAILED:
      return rhsDeviceDataLoadingProgress.setLoadFailed(state);
    case constants.RHS_DEVICE_DATA_LOAD_SUCCESS:
      return loadRhsDeviceData(state, action);

    case constants.ALL_DEVICES_RHS_DATA_LOAD_START:
      return allDevicesRhsDataLoadingProgress.setLoading(state);
    case constants.ALL_DEVICES_RHS_DATA_LOAD_FAILED:
      return allDevicesRhsDataLoadingProgress.setLoadFailed(state);
    case constants.ALL_DEVICES_RHS_DATA_LOAD_SUCCESS:
      return loadAllDevicesRhsData(state, action);

    case constants.RHS_COLOR_DEVICE_DATA_LOAD_START:
      return rhsColorDeviceDataLoadingProgress.setLoading(state);
    case constants.RHS_COLOR_DEVICE_DATA_LOAD_FAILED:
      return rhsColorDeviceDataLoadingProgress.setLoadFailed(state);
    case constants.RHS_COLOR_DEVICE_DATA_LOAD_SUCCESS:
      return loadRhsColorDeviceData(state, action);

    case constants.TEMPERATURE_DEVICE_DATA_LOAD_START:
      return temperatureDeviceDataLoadingProgress.setLoading(state);
    case constants.TEMPERATURE_DEVICE_DATA_LOAD_FAILED:
      return temperatureDeviceDataLoadingProgress.setLoadFailed(state);
    case constants.TEMPERATURE_DEVICE_DATA_LOAD_SUCCESS:
      return loadTemperatureDeviceData(state, action);

    case constants.HUMIDITY_DEVICE_DATA_LOAD_START:
      return humidityDeviceDataLoadingProgress.setLoading(state);
    case constants.HUMIDITY_DEVICE_DATA_LOAD_FAILED:
      return humidityDeviceDataLoadingProgress.setLoadFailed(state);
    case constants.HUMIDITY_DEVICE_DATA_LOAD_SUCCESS:
      return loadHumidityDeviceData(state, action);

    case constants.PEAK_COUGHING_HOUR_DATA_LOAD_START:
      return peakCoughingHourDataLoadingProgress.setLoading(state);
    case constants.PEAK_COUGHING_HOUR_DATA_LOAD_FAILED:
      return peakCoughingHourDataLoadingProgress.setLoadFailed(state);
    case constants.PEAK_COUGHING_HOUR_DATA_LOAD_SUCCESS:
      return loadPeakCoughingHourData(state, action);

    case constants.PEAK_COUGHING_HOUR_DEVICE_DATA_LOAD_START:
      return peakCoughingHourDeviceDataLoadingProgress.setLoading(state);
    case constants.PEAK_COUGHING_HOUR_DEVICE_DATA_LOAD_FAILED:
      return peakCoughingHourDeviceDataLoadingProgress.setLoadFailed(state);
    case constants.PEAK_COUGHING_HOUR_DEVICE_DATA_LOAD_SUCCESS:
      return loadPeakCoughingHourDeviceData(state, action);

    case constants.MORTALITY_DATA_LOAD_START:
      return mortalityDataLoadingProgress.setLoading(state);
    case constants.MORTALITY_DATA_LOAD_FAILED:
      return mortalityDataLoadingProgress.setLoadFailed(state);
    case constants.MORTALITY_DATA_LOAD_SUCCESS:
      return loadMortalityData(state, action);

    case constants.MORTALITY_PERCENTAGE_DATA_LOAD_START:
      return mortalityPercentageDataLoadingProgress.setLoading(state);
    case constants.MORTALITY_PERCENTAGE_DATA_LOAD_FAILED:
      return mortalityPercentageDataLoadingProgress.setLoadFailed(state);
    case constants.MORTALITY_PERCENTAGE_DATA_LOAD_SUCCESS:
      return loadMortalityPercentageData(state, action);

    case constants.MORTALITY_REASONS_LOAD_START:
      return mortalityReasonsLoadingProgress.setLoading(state);
    case constants.MORTALITY_REASONS_LOAD_FAILED:
      return mortalityReasonsLoadingProgress.setLoadFailed(state);
    case constants.MORTALITY_REASONS_LOAD_SUCCESS:
      return loadMortalityReasons(state, action);

    case constants.LOGBOOK_LOAD_START:
      return logbookLoadingProgress.setLoading(state);
    case constants.LOGBOOK_LOAD_FAILED:
      return logbookLoadingProgress.setLoadFailed(state);
    case constants.LOGBOOK_LOAD_SUCCESS:
      return loadLogbook(state, action);

    case constants.SITE_BATCHES_LOAD_START:
      return siteBatchesLoadingProgress.setLoading(state);
    case constants.SITE_BATCHES_LOAD_FAILED:
      return siteBatchesLoadingProgress.setLoadFailed(state);
    case constants.SITE_BATCHES_LOAD_SUCCESS:
      return loadSiteBatches(state, action);

    case constants.SITE_EXPORTS_LOAD_START:
      return siteExportsLoadingProgress.setLoading(state);
    case constants.SITE_EXPORTS_LOAD_FAILED:
      return siteExportsLoadingProgress.setLoadFailed(state);
    case constants.SITE_EXPORTS_LOAD_SUCCESS:
      return loadSiteExports(state, action);

    case constants.EXPORTS_CREATE_START:
      return createExportsLoadingProgress.setLoading(state);
    case constants.EXPORTS_CREATE_FAILED:
      return createExportsLoadingProgress.setLoadFailed(state);
    case constants.EXPORTS_CREATE_SUCCESS:
      return createExportsLoadingProgress.setLoaded(state);

    case constants.AIRSPACE_EXPORTS_LOAD_START:
      return airspaceExportsLoadingProgress.setLoading(state);
    case constants.AIRSPACE_EXPORTS_LOAD_FAILED:
      return airspaceExportsLoadingProgress.setLoadFailed(state);
    case constants.AIRSPACE_EXPORTS_LOAD_SUCCESS:
      return loadAirspaceExports(state, action);

    case constants.V3_SITE_BATCHES_LOAD_START:
      return v3SiteBatchesLoadingProgress.setLoading(state);
    case constants.V3_SITE_BATCHES_LOAD_FAILED:
      return v3SiteBatchesLoadingProgress.setLoadFailed(state);
    case constants.V3_SITE_BATCHES_LOAD_SUCCESS:
      return loadV3SiteBatches(state, action);

    case constants.CLEAR:
      return clear(state);

    case constants.CLEAR_LOGBOOK:
      return clearLogbook(state);

    case constants.CLEAR_GRAPHS:
      return clearGraphs(state);

    default:
      return state;
  }
};
